import { faCircleCheck } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import copy from 'copy-to-clipboard'
import React, { useState } from 'react'
import { LuCopy } from 'react-icons/lu'

import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { filterText } from '@/pages/professionalNetworkInvite/helpers'

type Props = React.ComponentProps<typeof Button> & {
  buttonText: string
  textToCopy: string
  format?: 'text/html' | 'text/plain'
}

const CopyLink: React.FC<Props> = ({
  variant,
  buttonText,
  textToCopy,
  format = 'text/plain',
  onClick,
  className,
  ...props
}) => {
  const [clicked, setClicked] = useState(false)
  const isLinkVariant = variant === 'link'

  return (
    <Button
      {...props}
      variant={clicked && !isLinkVariant ? 'success' : variant}
      onClick={(event) => {
        if (typeof onClick === 'function') {
          onClick(event)
        }

        if (textToCopy.length) {
          copy(filterText(textToCopy), {
            format: format,
          })
        }

        setClicked(true)

        setTimeout(() => {
          setClicked(false)
        }, 1500)
      }}
      className={cn(
        { 'text-success': clicked && isLinkVariant },
        'gap-2',
        className,
      )}
    >
      {clicked ? (
        <>
          <FontAwesomeIcon icon={faCircleCheck} />
          Copied
        </>
      ) : (
        <>
          <LuCopy />
          {buttonText}
        </>
      )}
    </Button>
  )
}

export default CopyLink
